import http from '@/service/http'
import { CommonUrl } from '@/common/url'
import * as T from './types'

export const commonApi: T.ICommonApi = {
  getTimeOrUnit(params) {
    return http.post(CommonUrl.TimeOrUnit, params)
  },
  runCheckRole(params) {
    return http.get(CommonUrl.CheckRole, params)
  },
  getBillSwitch(params) {
    return http.get(CommonUrl.GETBILLSWITCH, params)
  },
  getConfigFleetMineCenter(params) {
    return http.get(CommonUrl.ConfigFleetMineCenter, params)
  },
  getConfigFleetSettings(params) {
    return http.get(CommonUrl.ConfigFleetSettings, params)
  },
  getConfigOnShelf(params) {
    return http.get(CommonUrl.ConfigOnShelf, params)
  },
  getConfigDriverMarket(params) {
    return http.get(CommonUrl.ConfigDriverMarket, params)
  },
  getConfigVehicleDetail(params) {
    return http.get(CommonUrl.ConfigVehicleDetail, params)
  },

  getConfigDriverMineCenter(params) {
    return http.get(CommonUrl.ConfigDriverMineCenter, params)
  },
  getConfigDriverSettings(params) {
    return http.get(CommonUrl.ConfigDriverSettings, params)
  },
  getConfigDriverResume(params) {
    return http.get(CommonUrl.ConfigDriverResume, params)
  },
  getConfigVehicleMarket(params) {
    return http.get(CommonUrl.ConfigVehicleMarket, params)
  },
  getConfigVehicleBanner(params) {
    return http.get(CommonUrl.ConfigVehicleBanner, params)
  },

  getConfigFleetMsgForFe(params) {
    return http.get(CommonUrl.ConfigFleetMsgForFe, params)
  },
  getConfigDriverMsgForFe(params) {
    return http.get(CommonUrl.ConfigDriverMsgForFe, params)
  },

  checkLegalNotice(params) {
    return http.get(CommonUrl.CheckLegalNotice, params)
  },
  agreeLegalNotice(params) {
    return http.post(CommonUrl.AgreeLegalNotice, params)
  },

  getDriverBehavior(params) {
    return http.get(CommonUrl.DriverBehavior, params)
  },
  saveDriverBehavior(params) {
    return http.post(CommonUrl.SaveDriverBehavior, params)
  },

  getPictureAuditStatus(params) {
    return http.get(CommonUrl.PictureAuditStatus, params)
  },
}